import React from 'react';
import { Input } from 'semantic-ui-react';
import classNames from 'classnames';

import { InputMode } from 'Common/FormEnum';
import { isDetailIngredient } from 'Pages/manageproduction/helpers/productionRecord';
import { getValueFromInputMode } from 'Common/GeneralHelper';

function GridInputCell(props) {
  const {
    isReadOnly,
    inputProps: { inputLabelProps, onChange, className, ...rest } = {},
    mode,
    numericSize,
  } = props;
  const isIngredient = isDetailIngredient(props);

  if (isIngredient) {
    return <Input className="menu-input" disabled value="" />;
  }

  return (
    <Input
      className={classNames('menu-input', className)}
      autoComplete="off"
      fluid
      mode={InputMode.Integer}
      disabled={isReadOnly}
      onChange={(e) => {
        e.target.value = getValueFromInputMode(
          mode,
          numericSize || [12, 2],
          e.target.value
        );

        if (onChange) {
          onChange(e);
        }
      }}
      {...inputLabelProps}
      {...rest}
    />
  );
}

export { GridInputCell };



// WEBPACK FOOTER //
// ./src/pages/manageproduction/subpages/editproduction/components/GridInputCell.js